<div class="container-fluid d-flex justify-content-center align-items-center w-100">
	<div class="card m-0 shadow-sm border-white rounded my-auto w-100">
		<app-header></app-header>
		<div class="card-body w-100">
			<div class="d-flex flex-column justify-content-between align-items-center custom-card-height">
				<div class="mt-4 col-12 col-md-4" *ngIf="showCheckingCredit">
					<div class="row mt-2">
						<div class="col text-center fade-in d-flex align-items-center justify-content-center gap-2">
							<div class="spinner-border spinner-border-sm text-primary" role="status">
							  <span class="visually-hidden">Loading...</span>
							</div>
							<span class="text-medium">Performing credit check...</span>
						  </div>
					</div>
				</div>

				<div class="mt-4 col-12 col-md-4" [hidden]="showCheckingCredit">
					<div class="row mt-2">
						<div class="col text-center text-primary">You're qualified!</div>
					</div>
					<div class="row mt-2">
						<div class="col text-center">Use your finger to sign in the box</div>
					</div>
					<div class="row">
						<div class="col text-center">
							<canvas class="border rounded" #canvas (touchstart)="startDrawing($event)"
								(touchmove)="moved($event)"></canvas>
						</div>
					</div>
					<div class="row">
						<div class="d-grid gap-2 col-6 mx-auto space-after grid-button">
							<button class="btn btn-zain" (click)="clearPad()">Clear</button>
						</div>
					</div>
					<div class="row mt-2">
						<div class="d-grid gap-2 col-6 mx-auto space-after grid-button">
							<button (click)="submit()" class="btn bg-gradient btn-zain btn-zain-next">Submit</button>
						</div>
					</div>
				</div>


				<div *ngIf="isLoading" class="spinner-grow text-danger" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>
		</div>
	</div>
</div>